/* section-orsa-search.js
   ORSA — Search page interactions
   - clear button:
       - if on results: go back to /search (discover)
       - if on discover + typed: clear input
       - if empty: history.back()
   - sync data-has-value for clear button opacity
   - tabs switch between panes + grids client-side
*/
(() => {
  const root = document.querySelector("[data-orsa-search]");
  if (!root) return;

  const form = root.querySelector("[data-orsa-search-form]");
  const input = root.querySelector("[data-orsa-search-input]");
  const clearBtn = root.querySelector("[data-orsa-search-clear]");
  const tabs = Array.from(root.querySelectorAll("[data-orsa-tab]"));

  const panes = Array.from(root.querySelectorAll("[data-orsa-pane]"));
  const gridWraps = Array.from(root.querySelectorAll("[data-orsa-gridwrap]"));

  if (!form || !input || !clearBtn) return;

  const sync = () => {
    form.dataset.hasValue = input.value.trim().length ? "true" : "false";
  };

  sync();
  input.addEventListener("input", sync);
  input.addEventListener("change", sync);

  clearBtn.addEventListener("click", (e) => {
    e.preventDefault();

    const hasValue = input.value.trim().length > 0;
    const onResults =
      !!root.querySelector("[data-orsa-results]") ||
      new URLSearchParams(window.location.search).has("q");

    // If we're on results and they click X, go back to discover page
    if (hasValue && onResults) {
      const action = form.getAttribute("action") || "/search";
      window.location.href = action;
      return;
    }

    // If they typed (discover) just clear
    if (hasValue) {
      input.value = "";
      sync();
      input.focus();
      input.dispatchEvent(new Event("input", { bubbles: true }));
      return;
    }

    // If empty => close
    history.back();
  });

  const setActiveTab = (name) => {
    tabs.forEach((btn) => {
      const isActive = btn.getAttribute("data-orsa-tab") === name;
      btn.classList.toggle("is-active", isActive);
      btn.setAttribute("aria-selected", isActive ? "true" : "false");
    });

    panes.forEach((p) => {
      const isActive = p.getAttribute("data-orsa-pane") === name;
      if (isActive) p.removeAttribute("hidden");
      else p.setAttribute("hidden", "");
    });

    gridWraps.forEach((g) => {
      const isActive = g.getAttribute("data-orsa-gridwrap") === name;
      if (isActive) g.removeAttribute("hidden");
      else g.setAttribute("hidden", "");
    });
  };

  tabs.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      setActiveTab(btn.getAttribute("data-orsa-tab"));
    });
  });
})();